import srv from '@/store/services/services-service';

const state = {
    list: {},
    service: {},
    importResult: {},
    meta: {},
    alert: {
        id: null,
        message: '',
        type: "warning"
    },
};

const mutations = {
    SET_LIST: (state, list) => {
        state.list = list;
    },
    SET_RESOURCE: (state, service) => {
        state.service = service;
    },
    SET_IMPORT_RESULT: (state, result) => {
        state.importResult = result;
    },
    SET_META: (state, meta) => {
        state.meta = meta;
    },
    SET_ALERT: (state, alert) => (state.alert = alert),
};

const actions = {
    list({ commit, dispatch }, params) {
        return srv.list(params)
            .then(({ list, meta }) => {
                commit('SET_LIST', list);
                commit('SET_META', meta);
            });
    },

    get({ commit, dispatch }, params) {
        return srv.get(params)
            .then((role) => { commit('SET_RESOURCE', role); });
    },

    add({ commit, dispatch }, params) {
        return srv.add(params)
            .then((service) => { commit('SET_RESOURCE', service); });
    },

    multipleAdd({ commit }, params) {
        return srv.multipleAdd(params)
            .then((result) => { commit("SET_IMPORT_RESULT", result); });
    },

    update({ commit, dispatch }, params) {
        return srv.update(params)
            .then((service) => { commit('SET_RESOURCE', service); });
    },

    destroy({ commit, dispatch }, params) {
        return srv.destroy(params);
    },

    setAlert({ commit, dispatch }, alert) {
        setTimeout(()=>{
            alert.message = '';
            alert.id = null;
        }, 8000)
        commit('SET_ALERT', alert);
    },
};

const getters = {
    list: state => state.list,
    listTotal: state => state.meta.page.total,
    service: state => state.service,
    url: state => state.url,
    importResult: state => state.importResult,
    alert: state => state.alert,
    dropdown: (state) => {
        return state.list
            .filter(service => service.is_active) // tylko aktywne
            .map(service => ({
                id: service.id,
                name: service.name + ' (' + service.description + ')'
            }));
    },
};

const service = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};

export default service;